import { memo, useEffect, useState } from "react";
import { MeshRefractionMaterial } from "@react-three/drei";
import { random_choice, random_num } from "../common/utils";
import { featuresContext as features } from "./features";

const Crystal = ({ nodes, texture, baseScale, palette }) => {
  const scaling = (0.8 * baseScale) / 4; // random_num(0.1, 0.8) * (baseScale / 4);
  const [color, setColor] = useState(null);

  useEffect(() => {
    if (!color) {
      setColor(random_choice(palette));
    }
  }, [color, palette]);

  return (
    <mesh
      castShadow
      geometry={nodes.Cube.geometry}
      scale={[scaling, scaling * random_num(0.3, 0.8), scaling]}
      position-x={random_num(-1 * (baseScale / 4), 1 * (baseScale / 4))}
      position-y={random_num(0 + baseScale / 4, 1.5 - scaling) - baseScale / 2}
      position-z={random_num(-1 * (baseScale / 4), 1 * (baseScale / 4))}
      rotation={[
        random_num(-0.15, 0.15) * Math.PI,
        random_num(-0.15, 0.15) * Math.PI,
        random_num(-0.15, 0.15) * Math.PI,
      ]}
      texture={texture}
    >
      <MeshRefractionMaterial
        envMap={texture}
        transparent
        color={color}
        bounces={8}
        aberrationStrength={0.01}
        ior={2.8}
        fresnel={1}
        fastChroma
        toneMapped={false}
      />
    </mesh>
  );
};

const Crystals = ({ nodes, texture, baseScale }) => {
  const crystalPalette = features.palette.crystals;

  return (
    <>
      {[...Array(40)].map((_crystal, i) => {
        return (
          <Crystal
            key={i}
            nodes={nodes}
            baseScale={baseScale}
            texture={texture}
            palette={crystalPalette}
          />
        );
      })}
    </>
  );
};

export default memo(Crystals);
